import Route from 'cio/routes/base';
import PostRegistrationController from 'cio/pods/authenticated/post-registration/controller';

export default class PostRegistrationRoute extends Route {
  redirect() {
    let { queryParams } = this.router.currentRoute;
    let controller = this.controllerFor('authenticated.post-registration') as PostRegistrationController;
    if (controller.signupController.model.signupType.isDataPipelines) {
      return this.router.transitionTo('authenticated.post_registration.goal', { queryParams });
    } else {
      return this.router.transitionTo('authenticated.post_registration.role', { queryParams });
    }
  }
}
